import React, { useState } from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import { downloadSample, uploadMonthly } from "../api/monthly";

const UploadMonthly = () => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);

  const navigate = useNavigate();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleDownloadSample = async () => {
    try {
      const response = await downloadSample();
      if (response.status === "success" && response.file_url) {
        const link = document.createElement("a");
        link.href = `https://${response.file_url}`;
        link.download = "sample_monthly_target.csv";
        link.click();
      } else {
        toast.error("Failed to fetch the sample file URL.",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error("Error fetching sample file:", error);
      toast.error("An error occurred while downloading the sample file.",{
        autoClose: false,
        closeOnClick: true,
        draggable: true,
      });
    }
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const form = new FormData();
    if (file) form.append("file", file, file.name);

    try {
      setLoading(true);
      const emptyFields = [];
      if (file === null) {
        emptyFields.push("file");
      }

      setInvalidFields(emptyFields);

      if (emptyFields.length > 0) {
        toast.error("Please fill all required fields.");
        return;
      }
      const response = await uploadMonthly(form);
      if (!response) {
        toast.error("No data received or malformed response",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
        console.warn("No data received or malformed response:", response);
        return;
      }
      toast.success(response?.message);
      setTimeout(() => {
        navigate(URL_MAPPING.EMPLOYEEMONTHLY);
      }, 2000);
    } catch (error: any) {
      console.error("Failed to fetch media data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later");
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the media",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg,{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          }));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.",{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <button
          onClick={() => window.history.back()}
          className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="10"
            height="10"
            viewBox="0 0 256 256"
            xmlSpace="preserve"
          >
            <g
              style={{
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1,
              }}
              transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
            >
              <polygon
                points="20.48,45 59.75,90 69.52,81.48 37.69,45 69.52,8.52 59.75,0 "
                style={{
                  stroke: "none",
                  strokeWidth: 1,
                  strokeDasharray: "none",
                  strokeLinecap: "butt",
                  strokeLinejoin: "miter",
                  strokeMiterlimit: 10,
                  fill: "rgb(0,0,0)",
                  fillRule: "nonzero",
                  opacity: 1,
                }}
                transform="  matrix(1 0 0 1 0 0) "
              />
            </g>
          </svg>
        </button>
        <h3 className="text-xl font-bold text-gray-700"> Upload Monthly</h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
        <div className="flex items-center gap-4 my-2">
          <div className="flex-1">
            <label className="block font-semibold mb-1">File *</label>
            <input
              type="file"
              name="file"
              accept="*"
              onChange={handleFileChange}
              className={getInputClass("file")}
              style={{ width: "100%", minWidth: "600px", maxWidth: "100%" }}
            />
          </div>
          <div className="flex-1 mt-6">
            <button
              type="button"
              onClick={handleDownloadSample}
              style={{ whiteSpace: "nowrap" }}
              className="bg-blue-500 text-white px-8 py-2 rounded hover:bg-blue-600 text-base"
            >
              Download Sample
            </button>
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
        >
          Upload Targets {loading && <ButtonLoader />}
        </button>
      </form>
    </LayerAdmin>
  );
};

export default UploadMonthly;
